import { useEffect, useState } from "react";
import { WeatherCityType, WeatherForecastType, WeatherType } from "./weatherType";
import settingsData from "./weather.json"
import { NO_FORECAST, NO_FORECASTS, REFRESH_TIMEOUT_IN_MS, convert } from "./weatherFunctions";
import useLocalStorageState from "use-local-storage-state";
const settings: WeatherType = settingsData as any;


function WeatherCity({city}:{city: WeatherCityType}) {
    
    const [forecasts, setForecasts] = useLocalStorageState("weather", { storageSync: false, defaultValue: NO_FORECASTS });
    const [status, setStatus] = useState("" as string);

    const updateForecasts = (oldForecast: WeatherForecastType, newForecast: WeatherForecastType) => {

        if (newForecast === NO_FORECAST) 
        {
            if (oldForecast.lastDownload) {
                setForecasts(forecasts.filter(forecast => forecast.city !== city.apiName));
            }
        }
        else // newForecast exists
        {
            if (oldForecast.lastDownload) {
                setForecasts(forecasts.map((forecast) => forecast.city === city.apiName ? newForecast : forecast));
            }
            else {
                setForecasts((forecasts) => [...forecasts, newForecast]);
            }
        }
        
    }

    useEffect(() => {
        
        const oldForecast: WeatherForecastType = forecasts.find(forecast => forecast.city && forecast.city === city.apiName) ?? NO_FORECAST;
        
        if (oldForecast.lastDownload && (window.Date.now() - oldForecast.lastDownload) < REFRESH_TIMEOUT_IN_MS)
        {} // If data exists and has less than 3h
        else
        {
            if (oldForecast.lastDownload) {
                setStatus("Pobieram aktualizację...");
            } else {
                setStatus("Pobieram dane...");
            }

            let timerId = setTimeout(() => {
                const url = `https://api.weatherapi.com/v1/forecast.json?key=${settings.apiKey}&q=${city.apiName}&days=3&aqi=no&alerts=no`;
                fetch(url, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'omit', // This option disables cookies for the request
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    const newForecast = convert(city.apiName, data);
                    updateForecasts(oldForecast, newForecast);
                    setStatus("");
                })
                .catch(error => {
                    console.log('Fetch error:', error);
                    updateForecasts(oldForecast, NO_FORECAST);
                    setStatus("Nie udało się pobrać danych :(");
                });
            }, 700);            

            return () => {window.clearTimeout(timerId)}
        }        
        
    }, []);


    return(
        <>
            <div className="page-title">
                Prognoza pogody
            </div>
            <div className='boxes-contener'>
                <div className='text-box-header'>{city.name}</div>
                {status !== "" &&
                    <div className="paragraf">{status}</div>
                }
            </div>
            <div className='boxes-contener'>
                {forecasts.find(forecast => forecast.city === city.apiName)?.days?.map((day, index) =>
                    <div className='text-box' key={index}>
                        <div className='text-box-header'>{day.date}</div>
                        <div className='weather-data-table'> 
                            <div className='weather-data-table-row'>
                                <p className='weather-data-table-row-key'>Opis</p>
                                <p className='weather-data-table-row-value'>{day.condition}</p>
                            </div>                        
                            <div className='weather-data-table-row'>
                                <p className='weather-data-table-row-key'>Temperatura maksymalna</p>
                                <p className='weather-data-table-row-value'>{day.maxtemp_c}&deg;C</p>
                            </div>
                            <div className='weather-data-table-row'>
                                <p className='weather-data-table-row-key'>Temperatura minimalna</p>
                                <p className='weather-data-table-row-value'>{day.mintemp_c}&deg;C</p>
                            </div>
                            <div className='weather-data-table-row'>
                                <p className='weather-data-table-row-key'>Porywy wiatru do</p>
                                <p className='weather-data-table-row-value'>{day.maxwind_kph} km/h</p>
                            </div>
                            <div className='weather-data-table-row'>
                                <p className='weather-data-table-row-key'>Szacowana suma opadu</p>
                                <p className='weather-data-table-row-value'>{day.totalprecip_mm} mm</p>
                            </div>
                            <div className='weather-data-table-row'>
                                <p className='weather-data-table-row-key'>Indeks UV</p>
                                <p className='weather-data-table-row-value'>{day.uv}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>                
        </>
    )
}

export default WeatherCity;